import React from 'react';
import PropTypes from 'prop-types';
import WithConfig from 'config/WithConfig';
import SpotImagesDesktop from './SpotImagesDesktop';

const LargerImagesModalContentDesktop = ({
    cloudinary,
    cloudinaryTransformations,
    images,
    facilityTitle
}) => {
    return (
        <div className="LargerImagesModalContent">
            <SpotImagesDesktop
                images={images}
                showThumbnails={false}
                width={504}
                height={412}
            />
        </div>
    );
};

LargerImagesModalContentDesktop.propTypes = {
    cloudinary: PropTypes.object,
    cloudinaryTransformations: PropTypes.func,
    images: PropTypes.arrayOf(PropTypes.object),
    facilityTitle: PropTypes.string
};

export default WithConfig(LargerImagesModalContentDesktop);
